import AppBaseComponent from "../../../components/AppBaseComponent";
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Ax from "../../../components/hoc/Ax";
import Loader from "../../../components/ui/Loader/Loader";
import HttpAPICall from '../../../services/HttpAPICall';
import tapIcon from "../../../services/TapIcon";
import React from "react";

class SmsBalanceWidget extends AppBaseComponent {

    constructor(props) {
        super(props);
        this.state                      =   {
            loading                     :      false,
            data                        :       null,
        }
    }

    componentDidMount() {
        
        this.getSmsListing()
        
    }

    getSmsListing                =   (reload=false)  =>  {
        this.setState({loading: true});
        HttpAPICall.withAthorization('GET',process.env.REACT_APP_SERVER_PATH + '/backoffice/sms_balance', this.props.access_token,{}, {} , (response) => {
            this.setState({data : response.data.data}) 
        }).then(() => this.setState({loading: false}));
    }

    render                      =   ()  =>  {
     
        return (<div className="card mt-3">
            <div className="card-body">
                <div className="row">
                    <div className="col-5">
                        <h6 className="fw-bold primary_color">Sms Balance</h6>
                    </div>
                    <div className="col-3">

                    </div>
                    <div className="col-3 p0">

                    </div>
                    <div className="col-1 px-0 mx-0 text-center">
                        <tapIcon.imageIcon icon={tapIcon.ListActionIcon} alt="action-icon" className="img-fluid px-2 btn btn-light btn-block" data-bs-toggle="dropdown" href="#" role="button" aria-expanded="false" />
                        <ul className="dropdown-menu dropdown-menu-end">
                            <li className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => this.getSmsListing()}>Refresh</li>
                        </ul>
                    </div>
                </div>
                <div className="row mt-2 align-items-center">

                    <div className="col-12">
                        <table className="table table-hover table-bordered table-borderless bg-white my-2">
                         
                            <tbody>
                                {this.state.loading
                                    ? (<tr><td colSpan="2"><Loader /></td></tr>)
                                    :
                                    this.state.data ? <Ax>
                                        <tr>
                                            <td>{this.state.data}</td>
                                            
                                        </tr>
                                       
                                    </Ax>

                                        : <tr><td className="text-center" colSpan={2}>No Record Found</td></tr>
                                }


                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>);
    }

}


const mapStateToProps = state => {
    return {
        access_token            :   state.auth.access_token,
        iam_user_sites          :   state.app && state.app.user_sites ? state.app.user_sites : [],
        all_periods             :   state.app && state.app.all_periods ? state.app.all_periods : [],
    };
};


export default connect(mapStateToProps)(SmsBalanceWidget);